module.exports = __webpack_public_path__ + "static/media/search.bb59eea0.svg";